import React, { SVGProps } from "react"

export function IconHarvest(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <rect fill="currentColor" width="16" height="16" rx="2" />
      <path
        fill="#FFF8F1"
        d="M7.4 9.3V13h-.7V7.4a.6.6 0 0 1 .7-.6h1.8v1.8a.6.6 0 0 1-.6.7H7.4ZM13 3v9.4a.6.6 0 0 1-.6.6h-.6V3.6a.6.6 0 0 1 .6-.6h.6ZM10.5 3h.6v9.4a.6.6 0 0 1-.6.6h-.6V6.1a.6.6 0 0 1 .6-.6V3ZM5.5 13h-.6V3.6a.6.6 0 0 1 .6-.6h.6v6.9a.6.6 0 0 1-.6.6V13ZM3 13V3.6a.6.6 0 0 1 .6-.6h.6v9.4a.6.6 0 0 1-.6.6H3Z"
      />
    </svg>
  )
}
